import React, { useEffect, createRef } from 'react';

import Scrollbar from '../../scrollbars';
import { Text } from '../../texts';
import { DropDownTextItem } from './dropdown-text-item';
import { getValue } from './input-utils';
import { Styled } from './styled';

const DropdownListComponent = (props) => {
  const {
    filteredElements,
    onClick,
    activeElement,
    maxItemsAmount,
    isShowNewValue,
    optionRenderer,
  } = props;
  const MAX_ITEMS_HEIGHTS = Styled.ITEM_HEIGHT * maxItemsAmount;
  const itemsHeight = filteredElements.length
    ? filteredElements.length * Styled.ITEM_HEIGHT > MAX_ITEMS_HEIGHTS
      ? MAX_ITEMS_HEIGHTS
      : filteredElements.length * Styled.ITEM_HEIGHT
    : Styled.ITEM_HEIGHT;
  const scrollRef = createRef();

  useEffect(() => {
    const firstActiveElementIndex =
      activeElement &&
      filteredElements.findIndex((el) => el === activeElement);

    if (firstActiveElementIndex !== undefined) {
      scrollRef.current.scrollbarRef.current.scrollTop(
        (firstActiveElementIndex - 2) * Styled.ITEM_HEIGHT
      );
    }
  }, [activeElement, filteredElements]);

  return (
    <Styled.DropDownMenuContainer
      height={itemsHeight}
      scrollHeight={filteredElements.length}
      isShowNoResults={!filteredElements.length && isShowNewValue}
    >
      <Scrollbar autoHide={false} ref={scrollRef}>
        {filteredElements.length ? (
          filteredElements.map((elem, index) => {
            const elementId = getValue(elem);
            const isActive = activeElement === elementId;

            return (
              <DropDownTextItem
                key={elem + index}
                id={elementId}
                onClick={onClick}
                isActive={isActive}
                content={elem}
                optionRenderer={optionRenderer}
              />
            );
          })
        ) : (
          <Styled.NoResults>
            <Text>No results found</Text>
          </Styled.NoResults>
        )}
      </Scrollbar>
    </Styled.DropDownMenuContainer>
  );
};

export const DropdownList = React.memo(DropdownListComponent);
